import {
  Scene as BaseScene
} from 'three';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { Utils } from './Utils';
import { store } from '../Store';

export default class Scene extends BaseScene {
  constructor(options, sceneViewer) {
    super(options);

    this.name = options.name;
    this.options = options;
  }

  initLoaders(renderer) {
    this.ktx2Loader = new KTX2Loader();
		this.ktx2Loader.setTranscoderPath( 'basis/' );
		this.ktx2Loader.detectSupport(renderer);

    this.gltfLoader = new GLTFLoader();
    this.gltfLoader.setKTX2Loader(this.ktx2Loader);
  }

  async loadCompressedTextures() {
    const materials = new Set();

    let progress = store.loadingPercentage;

    this.traverse(node => node.material && materials.add(node.material));

    for (const material of materials.values()) {
      if (!material.name.startsWith('Group')) continue;

      const filename = `${material.name}_bake.ktx2`;
      const filepath = `assets/scenes/${this.name}/${filename}`;
      const texture = await this.ktx2Loader.loadAsync(filepath);

      store.setLoadingPercentage(progress += 10);

      console.log(`${filename} transcoded to ${Utils.getTextureFormat(texture)}`);

      material.map = texture;
    }
  }

  async loadGLTF() {
    return new Promise((resolve, reject) => {
      this.gltfLoader.load(this.options.filepath, async(result) => {
        this.add(result.scene);

        store.setLoadingPercentage(50);

        await this.loadCompressedTextures();

        resolve(result);
      }, (onProgressEvent) => {

      });
    });
  }

  async load(renderer) {
    this.initLoaders(renderer);

    await this.loadGLTF();
  }

  onLoad(sceneViewer) {
    // override in child classes
  }

  update() {
    // override in child classes
  }
}